import React, { Fragment } from 'react';

import {
  FetchProductsCacheKeys,
  UpdateProductCacheAction
} from '../../../../../../products/productsTypes';
import {
  UpdateProductsSetCacheAction,
  FetchProductsSetsCacheKeys
} from '../../../../../../productsSets/productsSetsTypes';
import {
  ThreeDStockProductsListLightboxBottomButtonsProduct,
  ThreeDStockProductsListLightboxBottomButtonsProductsSet
} from './ThreeDStockProductsListLightboxBottomButtons.types';

import { ThreeDStockProductsListLightboxSelectButton } from '../ThreeDStockProductsListLightboxSelectButton';

interface ThreeDStockProductsListLightboxBottomButtonsDefaultProps {
  product: ThreeDStockProductsListLightboxBottomButtonsProduct;
  productsCacheKeys?: FetchProductsCacheKeys;
  updateProductCache?: UpdateProductCacheAction<ThreeDStockProductsListLightboxBottomButtonsProduct>;
}

interface ThreeDStockProductsListLightboxBottomButtonsWithSelectProps {
  productsSet: ThreeDStockProductsListLightboxBottomButtonsProductsSet | null;
  productsSetCacheKeys?: FetchProductsSetsCacheKeys;
  updateProductsSetCache: UpdateProductsSetCacheAction<ThreeDStockProductsListLightboxBottomButtonsProductsSet>;
}

interface ThreeDStockProductsListLightboxBottomButtonsWithoutProps {
  productsSet?: never;
  productsSetCacheKeys?: never;
  updateProductsSetCache?: never;
}

type ThreeDStockProductsListLightboxBottomButtonsProps =
  ThreeDStockProductsListLightboxBottomButtonsDefaultProps &
    (
      | ThreeDStockProductsListLightboxBottomButtonsWithSelectProps
      | ThreeDStockProductsListLightboxBottomButtonsWithoutProps
    );

function ThreeDStockProductsListLightboxBottomButtons({
  product,
  productsSet,
  productsSetCacheKeys,
  updateProductsSetCache
}: ThreeDStockProductsListLightboxBottomButtonsProps) {
  return (
    <Fragment>
      <ThreeDStockProductsListLightboxSelectButton
        product={product}
        productsSet={productsSet}
        productsSetCacheKeys={productsSetCacheKeys}
        updateProductsSetCache={updateProductsSetCache}
      />
    </Fragment>
  );
}

export default ThreeDStockProductsListLightboxBottomButtons;
